import type { Maybe } from "../graphql/client"

export function isDefined<T>(item: T | null | undefined): item is T {
  return !!item
}

export function maybeHas<T>(item: Maybe<T>): item is T {
  return !!item
}
